import script from "./CommonWageEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonWageEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./CommonWageEditModal.vue?vue&type=style&index=0&id=b4630d4c&lang=scss"

const __exports__ = script;

export default __exports__